import {
  FETCH_DAY_DATE_WISE_SALES_DATA,
  FETCH_HOUR_WISE_SALES_DATA,
  FETCH_TOP_FAILURE_VM_DATA,
  FETCH_TOP_SELLING_BRANDS,
  FETCH_TOP_SELLING_PRODUCTS,
  FETCH_VM_PURCHASE_ANALYTICS,
  FETCH_VM_REVENUE_ANALYTICS,
  RESET_TOP_SELLING_BRANDS,
  RESET_TOP_SELLING_PRODUCTS,
} from "constants/action.constants";

const initialState = {
  dayDateWiseSalesData: [],
  hourWiseSalesData: [],
  topFailureVMData: [],
  topSellingProducts: [],
  topSellingBrands: [],
  purchaseAnalytics: {},
  vMSalesData: [],
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DAY_DATE_WISE_SALES_DATA:
      return { ...state, dayDateWiseSalesData: action.payload };
    case FETCH_HOUR_WISE_SALES_DATA:
      return { ...state, hourWiseSalesData: action.payload };
    case FETCH_TOP_FAILURE_VM_DATA:
      return { ...state, topFailureVMData: action.payload };
    case FETCH_TOP_SELLING_PRODUCTS:
      return { ...state, topSellingProducts: action.payload };
    case FETCH_TOP_SELLING_BRANDS:
      return { ...state, topSellingBrands: action.payload };
    case FETCH_VM_PURCHASE_ANALYTICS:
      return { ...state, purchaseAnalytics: action.payload };
    case FETCH_VM_REVENUE_ANALYTICS:
      return { ...state, vMSalesData: action.payload };
    case RESET_TOP_SELLING_PRODUCTS:
      return { ...state, topSellingProducts: [] };
    case RESET_TOP_SELLING_BRANDS:
      return { ...state, topSellingBrands: [] };
    default:
      return state;
  }
};

export default analyticsReducer;
